<template>
  <div>
    <div class="recommend-card white mx-auto w-100">
      <!-- CHILD INFO -->
      <router-link
        to
        @click.native="goToProfile"
        class="report-link font-weight-bold"
      >
        <div class="child-info">
          <div
            class="avatar avatar-square"
            :class="!child_img ? setAvatarBg : null"
          >
            <img
              v-lazy="child_img"
              :alt="child_name"
              class="avatar-img"
              :class="setAvatarBg"
              v-if="child_img"
            />
            <div class="avatar-text white-text" :class="setAvatarBg" v-else>
              {{ child_name | getInitials }}
            </div>
          </div>
          <div class="name color_text text-capitalize">
            {{ child_name }}
            <span class="percent" :class="state_color">
              ( {{ correct }}/{{ total }} | {{ percent_progress }}%)</span
            >
          </div>
        </div>
      </router-link>

      <!-- OPTION -->
      <div class="options">
        <!-- DESKTOP -->
        <div class="desktop-view">
          <!-- REMEDIAL OPTION -->
          <template v-if="data.recommendations.remedial">
            <div
              class="option"
              @click="toggleRemedialCard"
              v-if="data.recommendations.remedial.is_recommended === '0'"
            >
              <!-- AVATAR -->
              <div class="avatar">
                <span
                  class="flex-center icon-video-on brand_inverse font-22"
                ></span>
              </div>
              <!-- TEXT -->
              <div class="text">Remedial Class</div>
            </div>
          </template>

          <!-- VIDEO OPTION -->
          <template v-if="false">
            <div class="option ml-4" @click="toggleVideoCard">
              <!-- AVATAR -->
              <div class="avatar">
                <span
                  class="flex-center icon-video-card brand_tonic font-22"
                ></span>
              </div>
              <!-- TEXT -->
              <div class="text">Video</div>
            </div>
          </template>

          <!-- PRACTICE OPTION -->
          <template v-if="data.recommendations.resources">
            <div
              class="option ml-4"
              @click="toggleResourceCard"
              v-if="data.recommendations.resources.length"
            >
              <!-- AVATAR -->
              <div class="avatar">
                <span
                  class="flex-center icon-practice-card brand_navy font-22"
                ></span>
              </div>
              <!-- TEXT -->
              <div class="text">Resources</div>
            </div>
          </template>
        </div>

        <!-- MOBILE -->
        <div class="mobile-view d-lg-none">
          <!-- REMEDIAL CARD -->
          <div
            class="mobile-option mr-2"
            @click="toggleRemedialCard"
            v-if="data.recommendations.remedial"
          >
            <div class="avatar">
              <span
                class="flex-center icon-video-on brand_inverse font-20"
              ></span>
            </div>
          </div>
          <!-- REMEDIAL CARD -->

          <!--VIDEO CARD-->
          <div class="mobile-option mr-2" @click="toggleVideoCard" v-if="false">
            <div class="avatar">
              <span
                class="flex-center icon-video-card brand_tonic font-20"
              ></span>
            </div>
          </div>
          <!-- VIDEO CARD -->

          <!-- PRACTICE CARD -->
          <div
            class="mobile-option ml-2"
            @click="toggleResourceCard"
            v-if="data.recommendations.resources"
          >
            <div class="avatar">
              <span
                class="flex-center icon-practice-card brand_navy font-20"
              ></span>
            </div>
          </div>
          <!-- PRACTICE CARD -->
        </div>
      </div>
    </div>

    <!-- MODAL GOES HERE -->
    <SingleRemedialModal
      v-if="remedial_card"
      :data="data"
      :topic="data.recommendations.remedial"
      :subject="subject"
      @closeTriggered="toggleRemedialCard"
      @scheduled="scheduled"
    ></SingleRemedialModal>

    <ResourceCardModal
      v-if="resource_card"
      :user_data="data"
      :resources="data.recommendations.resources"
      @recommended="recommended"
      @closeTriggered="toggleResourceCard"
    ></ResourceCardModal>
    <!-- MODAL GOES HERE -->

    <RemidialSuccessModal
      v-if="show_alert"
      @closeTriggered="closeAlert"
      :message="message"
    ></RemidialSuccessModal>
  </div>
</template>

<script>
import { randomString } from "@/scripts/utilities";
import { setProfileBg } from "@/scripts/profile-colors";
import { mapGetters } from "vuex";

export default {
  name: "RecommendCard",

  props: {
    child_img: String,
    child_name: String,
    percent_progress: Number,
    data: {
      type: Object,
      required: true,
    },
    topic: Object,
    subject: Object,
    type: String,
    reference_type: String,
    correct: Number,
    total: Number,
    student_id: [Number, String],
  },

  components: {
    RemidialSuccessModal: () =>
      import(
        /* webpackChunkName: "alert" */
        "@/components/modalComps/teacherModals/RemidialSuccessModal"
      ),
    SingleRemedialModal: () =>
      import(
        /* webpackChunkName: "SingleRemedialModal" */
        "@/components/modalComps/classModals/SingleRemedialModal"
      ),
    ResourceCardModal: () =>
      import(
        /* webpackChunkName: "ResourceCardModal" */
        "@/components/modalComps/classModals/ResourceCardModal"
      ),
  },

  watch: {
    child_img: "updateCard",
    child_name: "updateCard",
    percent_progress: "updateCard",
  },

  computed: {
    ...mapGetters(["getCurrentClass"]),

    setAvatarBg() {
      return setProfileBg(this.child_name);
    },
  },

  data() {
    return {
      remedial_card: false,
      resource_card: false,
      state_color: "",
      show_alert: false,
      message: "",
      account_type: this.$route.path.split("/")[1],
    };
  },

  mounted() {
    this.updateCard();
  },

  filters: {
    getInitials(val) {
      const [f, l] = val.split(" ");
      return f[0] + "" + l[0];
    },
  },

  methods: {
    // GO TO STUDENT PROFILE
    goToProfile() {
      this.$router.push(
        `/${this.account_type}/student-profile?id=${this.generateId(
          this.student_id
        )}`
      );
    },

    generateId(id) {
      return `${randomString(11)}${id}`;
    },

    updateCard() {
      if (this.percent_progress >= 75) this.state_color = "green-text";
      else if (this.percent_progress >= 45 && this.percent_progress <= 74)
        this.state_color = "brand_accent";
      else if (this.percent_progress <= 44) this.state_color = "brand_tonic";
    },

    toggleRemedialCard() {
      this.remedial_card = !this.remedial_card;
    },

    toggleResourceCard() {
      this.resource_card = !this.resource_card;
    },

    scheduled() {
      this.show_alert = true;
      this.message = "Remedial successfully scheduled.";
      this.remedial_card = false;
    },

    recommended() {
      this.show_alert = true;
      this.message = "Resources successfully endorsed.";
      this.resource_card = false;
    },

    closeAlert() {
      this.show_alert = !this.show_alert;
    },
  },
};
</script>

<style lang="scss">
.recommend-card {
  padding-top: 12px;
  padding-bottom: 14px;
  padding-left: 20px;
  padding-right: 20px;
  border-bottom: 1px solid $border_grey;
  @include flex_row_between_nowrap;

  @include breakpoint_max(sm) {
    padding: 11px;
  }

  .child-info {
    @include flex_row_start_nowrap;

    .avatar {
      margin-right: 15px;

      @include breakpoint_max(sm) {
        margin-right: 10px;
      }

      .avatar-text {
        font-size: 13px;
      }
    }

    .name {
      font-size: 13px;
      line-height: 19px;

      @include breakpoint_max(lg) {
        font-size: 13px;
      }

      @include breakpoint_max(md) {
        font-size: 14px;
      }

      @include breakpoint_max(sm) {
        font-size: 12px;
      }

      @include breakpoint_max(xs) {
        font-size: 11.75px;
        font-weight: 600 !important;
      }
    }
  }

  .desktop-view,
  .mobile-view {
    @include flex_row_end_nowrap;
  }

  .mobile-view {
    @include breakpoint_min(lg) {
      display: none;
    }
  }

  .mobile-option {
    .avatar {
      span {
        @include breakpoint_max(sm) {
          font-size: 17px !important;
        }
        @include breakpoint_max(xs) {
          font-size: 16px !important;
        }
      }
    }
  }

  .desktop-view {
    @include breakpoint_max(lg) {
      display: none;
    }

    .option {
      @include flex_row_between_nowrap;
      padding: 2px 10px;
      cursor: pointer;
      background: #f5f5f5;
      border-radius: 30px;

      &:hover {
        background: #e9e9e9;
      }

      .avatar {
        margin-right: 13.5px;
      }

      .text {
        font-size: 13.5px;
        line-height: 19px;
        color: $color_ash;
      }
    }
  }
}
</style>
